var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root"}},[_c('div',{staticClass:"layout"},[_c('portfolio-header'),_c('social-links'),_c('sidebar-email'),_c('div',{attrs:{"id":"content"}},[_c('router-view'),_c('portfolio-footer')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }